<template>
    <div
        v-click-outside="hide"
        :class="{ expanded: isExpanded }"  
        class="container">

        <div 
            class="toggle"
            @click="toggle()">

            <slot name="toggle"/>
        
        </div>

        <div class="list-container">
            <div 
                class="list">
                <slot name="list"/>
            </div>
        </div>
    </div>

</template>

<script>

import ClickOutside from 'vue-click-outside';

export default {
    name: 'Dropdown',

    directives: {
        ClickOutside
    },

    props: {
        expanded: {
            type: Object,
            required: true
        }
    },

    data: function () {
        return {
            isExpanded: this.expanded.state
        };
    },


    watch: {
        expanded: function (newValue) {
            this.isExpanded = newValue.state;
        }
    },

    methods: {
        toggle: function () {
            this.isExpanded = !this.isExpanded;
        },

        hide: function () {
            this.isExpanded = false;
        }
    }
};
</script>

<style lang="less" scoped>

    @import "../styles/colors.less";
    @import "../styles/globals.less";

    .toggle {
        display: flex;
    }

    .container {
        position: relative;
    }

    .list {
        color: @default-text-color;
        border-radius: @border-radius;
        overflow: hidden;
           
        box-shadow: 0 0 16px 0 rgba(0,0,0,.3);
    }

    .list-container {
        position: absolute;
        display: none;
        z-index: 1;
        min-width: 100%;
        top: 28px;
        right: 0;
        margin-top: 8px;
    }

    .list-container:before {
        content: "";
        position: absolute;
        top: -24px;
        right: 0;
        height: 0;
        width: 0;
        border: 12px solid transparent;
        border-bottom-color: @color-white;
        margin-right: 4px;
    }

    .expanded .list-container {
        display: block;
    }

    .expanded .dropdown-icon {
        transform: rotateX(180deg);
    }


</style>


// WEBPACK FOOTER //
// src/components/Dropdown.vue